/*=========================================================================================
  File Name: state.js
  Description: Vuex Store - state
==========================================================================================*/
const state = {
    loading: true,
    pageLoader: false,
    shopLoader: false,
    error_message: false,
    success_message: false,
    message_type: false,
    frontend_notify: {
      title: false,
      text: false,
      type: false
    },
    psOptions: {
        suppressScrollX: true, suppressScrollY: false
    },
    psWatchOptions: true,
    status: '',
    permissions: false,
    token: localStorage.getItem('access-token') || '',
    user_id: localStorage.getItem('user_id') || null,
    primary_color: localStorage.getItem('primary_color') || null,
    local_active_language_id: null,
    user: {},
    profile: {},
    profileImage: null,
    profileImage_b: null,
    profileImage_s: null,
    coverImage: null,
    coverImage_b: null,
    coverImage_m: null,
    coverImage_s: null,
    organization_name: false,
    organization: {},
    activeLanguage: {},
    sidebarMenuAdminName: '',
    sidebarMenuAdmin: [],
    profileMenu: [],
    languageMenu: [],
    searchable: [],
    staredPages: [],

    languages: [],
    countries: [],
    tasksData: {tasks: [], users: [], clients: [], priorities: {}, statuses: {}},

    users: null,
    usersCount: null,

    pages: null,

    pricePopup: false,
    pricePopupData: null,
    priceClosePopup: false,

    invoiceTypePopup: false,
    invoiceTypePopupData: null,
    invoiceTypeClosePopup: false,

    invoiceNrPopup: false,
    invoiceNrPopupData: null,
    invoiceNrClosePopup: false,

    invoiceStatusPopup: false,
    invoiceStatusPopupData: null,
    invoiceStatusClosePopup: false,

    commentPopup: false,
    commentPopupData: null,
    commentClosePopup: false,

    implementationCommentPopup: false,
    implementationCommentPopupData: null,
    implementationCommentClosePopup: false,

    simpleCommentPopup: false,
    simpleCommentPopupData: null,
    simpleCommentClosePopup: false,

    clientEventUsers: [],
    clientEvents: [],
    clientCalendarPopup: false,
    clientCalendarData: null,
    clientCalendarClosePopup: false,

    clientTasksPopup: false,
    clientTasksData: null,
    clientTasksClosePopup: false,

    clientPaymentDifferencePopup: false,
    clientPaymentDifferenceData: null,
    clientPaymentDifferenceClosePopup: false,

    statusPopup: false,
    statusPopupData: null,
    statusClosePopup: false,

    communicationPopup: false,
    communicationPopupData: null,
    communicationClosePopup: false,

    monthsPopup: false,
    monthsPopupData: null,
    monthsClosePopup: false,

    implementationStatusPopup: false,
    implementationStatusPopupData: null,
    implementationStatusClosePopup: false,

    implementationSourcePopup: false,
    implementationSourcePopupData: null,
    implementationSourceClosePopup: false,

    implementationMovePopup: false,
    implementationMovePopupData: null,
    implementationMoveClosePopup: false,

    implementationMoveTabPopup: false,
    implementationMoveTabPopupData: null,
    implementationMoveTabClosePopup: false,

    createTabPopup: false,
    createTabPopupData: null,
    createTabClosePopup: false,

    scheduleStatusPopup: false,
    scheduleStatusPopupData: null,
    scheduleStatusClosePopup: false,

    sourcePopup: false,
    sourcePopupData: null,
    sourceClosePopup: false,

    clientTypePopup: false,
    clientTypePopupData: null,
    clientTypeClosePopup: false,

    sellerPopup: false,
    sellerPopupData: null,
    sellerClosePopup: false,

    managerPopup: false,
    managerPopupData: null,
    managerClosePopup: false,

    scheduleActiveMonth: null,
    scheduleActiveYear: null,
    scheduleCount: null,

    monthlyScheduleYear: null,
    monthlySchedulePreviousYear: null,
    monthlyScheduleMonth: null,
    monthlySchedulePreviousMonth: null,
    monthlySchedulePaymentType: null,
    monthlyScheduleSearch: null,
    monthlyScheduleCount: null,

    paymentPurposeCreatePopup: false,
    paymentPurposeCreateClosePopup: false,

    sourceCreatePopup: false,
    sourceCreateClosePopup: false,

    clientTypeCreatePopup: false,
    clientTypeCreateClosePopup: false,

    create_invoice: false,
    create_invoice_client: false,

    APP_NAME: "JKonsult",
    APP_URL: process.env.NODE_ENV === 'production' ? process.env.MIX_PROD_APP_URL : process.env.MIX_DEV_APP_URL,
    API_URL: process.env.NODE_ENV === 'production' ? process.env.MIX_PROD_API_URL : process.env.MIX_DEV_API_URL,

    page: null,
    title: null,

    // ////////////////////////////////////////////
    // SIDEBAR & UI UX
    // ////////////////////////////////////////////

    themeSettings: {

        default: {
            theme: 'semi-dark'
        },
        new: {}
    },
    basicOrganizationData: {
        logo: '/images/logos/logo.png',
        logo_b: '/images/logos/logo_b.png',
        logo_s: '/images/logos/logo_s.png',
        logo_big: '/images/logos/logo_big.png',
        logo_big_b: '/images/logos/logo_big_b.png',
        logo_big_s: '/images/logos/logo_big_s.png',
    },
    currentTranslations: false,

    confirmType: false,
    confirmEmail: false,
    confirmToken: false,


    isSidebarActive: true,
    breakpoint: null,
    sidebarWidth: "default",
    bodyOverlay: false,
    sidebarItemsMin: false,
    theme: {
        primary_color: '#1a73e8',
        mode: 'semi-dark',
        nav_bar_color: "#1a73e8",
        nav_bar_type: "sticky",
        animation: 'zoom-fade',
        sidebar_collapsed: false,
        show_customizer: true,
    },

    defaultTheme: {
        primary_color: '#1a73e8',
        mode: 'light',
        nav_bar_color: "#1a73e8",
        nav_bar_type: "sticky",
        animation: 'zoom-fade',
        sidebar_collapsed: false,
        show_customizer: true,
    },

    // Can be used to get current window with
    // Note: Above breakpoint state is for internal use of sidebar component
    windowWidth: null,

    // Health scores per account_id (loaded on /system/budgets mount)
    healthScoresByAccount: {},
};

export default state
